import { useState } from 'react';
import { useAppMode } from '../../state/appMode';
import { useReportState } from '../../state/reportState';

const ITEMS = [
  ['story', 'Story'], ['dashboard', 'Dashboard'], ['voices', 'Voices'], ['methodology', 'About'],
] as const;

export function SectionRail() {
  const { mode } = useAppMode();
  const { section, setSection } = useReportState();
  const [open, setOpen] = useState(false);
  const isPresenter = mode === 'presenter';
  return <>
    <nav className={`fixed left-5 top-5 z-50 hidden rounded-full border border-atc-navy/10 bg-white/90 p-1 shadow-atc-card backdrop-blur md:flex ${isPresenter ? 'opacity-70' : ''}`} aria-label="レポートのセクション">
      {ITEMS.map(([id, label]) => <button key={id} type="button" aria-current={section === id ? 'page' : undefined} onClick={() => setSection(id)} className={`rounded-full px-4 py-2 text-xs font-bold transition ${section === id ? 'bg-atc-navy text-white' : 'text-atc-slate hover:bg-atc-surface'}`}>{label}</button>)}
    </nav>
    <div className="fixed bottom-4 left-4 right-4 z-50 md:hidden">
      <button type="button" aria-expanded={open} aria-controls="section-drawer" onClick={() => setOpen((value) => !value)} className="ml-auto flex rounded-full bg-atc-navy px-5 py-3 text-sm font-bold text-white shadow-atc-card">セクション</button>
      {open && <nav id="section-drawer" className="mt-3 grid grid-cols-3 gap-2 rounded-2xl border border-atc-navy/10 bg-white p-2 shadow-atc-card" aria-label="レポートのセクション">
        {ITEMS.map(([id, label]) => <button key={id} type="button" onClick={() => { setSection(id); setOpen(false); }} className={`rounded-xl px-2 py-3 text-xs font-bold ${section === id ? 'bg-atc-navy text-white' : 'bg-atc-surface text-atc-ink'}`}>{label}</button>)}
      </nav>}
    </div>
  </>;
}
